// extracted by mini-css-extract-plugin
export var banner = "_rz-0";
export var settingRow = "_rz-2";
export var titleIcon = "_rz-1";